<!--Form-->
<div class="ahpr-MainGrid">
	<label>Pass Reason Code:</label>
	<input id="PassReasonCode" [(ngModel)]="PassReasonCode" class="form-control" type="text" />

	<label>Pass Reason Description:</label>
	<input id="PassReasonDesc" [(ngModel)]="PassReasonDesc" class="form-control" type="text" />

	<label>Default Pass Duration (Minutes):</label>
	<input min="0" id="DefaultPassDur" [(ngModel)]="DefaultPassDur" class="form-control" type="number" />

	<label for="IsQuickPass">Is Quick Pass? (Limited Data Entry):</label>
	<input id="IsQuickPass" [(ngModel)]="IsQuickPass" class="form-control" type="checkbox" />

	<label for="IsGroupAssign">Is Group Assignable?:</label>
	<input id="IsGroupAssign" [(ngModel)]="IsGroupAssign" class="form-control" type="checkbox" />

	<label for="IsAssignFromClass">Is Assignable from Classroom?:</label>
	<input id="IsAssignFromClass" [(ngModel)]="IsAssignFromClass" class="form-control" type="checkbox" />

	<label for="IsDistrictLevel">Is District Level?:</label>
	<input id="IsDistrictLevel" [(ngModel)]="IsDistrictLevel" class="form-control" type="checkbox" />

	<label for="UseClassAttnExcu">Use Class Attendance Excuse?:</label>
	<input id="UseClassAttnExcu" [(ngModel)]="UseClassAttnExcu" class="form-control" type="checkbox" />

	<label>Defined By:</label>
	<label class="ahpr-TypeText" [style.color]="GetTypeColor(UserType)">{{ UserType }}</label>
</div>

<!--Buttons-->
<div class="ahpr-Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Add Hall Pass Reason</button>
	<button class="btn btn-primary" (click)="onCancel()">Cancel</button>
</div>
